/**
 * CODE_COMMENTS_31
 * CODE_COMMENTS_58
 */

export const REPORT_SELF_COLLECTION_SHIPMENTS_FIELD_ARRAY_NAME = 'selfCollectionShipments'
